import TitlePageComponent from "./TitlePageComponent";

export default TitlePageComponent;
